import { css } from "@emotion/react";
import LEXEND from "assets/fonts/Presente/Lexend-VariableFont_wght.ttf";

const presenteStyles = css`
  @font-face {
    font-family: "Lexend";
    src: url(${LEXEND}) format("truetype");
  }

  &.presente {
    body {
      font-family: "Lexend", sans-serif;
    }

    .desk-width {
      .icon-container {
        .sub-button {
          background: #ffea00 !important;
          color: #ffffff !important;
        }
      }
    }

    .half-style {
      background: #415ef7 !important;

      .label-style {
        background: #ff9675 !important;
        color: #174f81 !important;
      }

      .latest-score {
        color: #f4f4f4 !important;
      }

      .score {
        color: #a8004a !important;
      }

      .second-half {
        .btn-container {
          background: #a8004a !important;
          box-shadow: #a8004a 0 12px 17px -7px !important;
          -webkit-box-shadow: #a8004a 0 12px 17px -7px !important;
        }
      }
    }

    .player-rank-board {
      .board-container {
        .first-board,
        .middle-board,
        .last-board {
          .tile {
            fill: #a8004a !important;
          }
        }
      }
    }

    .modal-content {
      .header-container {
        .logo-container {
          margin-bottom: 1rem;
        }
      }
    }

    .triangle-bg {
      fill: #415ef7 !important;
    }

    .top-tournament-full-width {
      .title-md {
        display: none !important;
      }
    }

    .desktop-view {
      .home-container {
        .header {
          display: none !important;
        }
      }
    }
  }
`;

export default presenteStyles;
